// @flow

import moment from "moment";

class DateFormatter {
    el: HTMLElement;
    dateFrom: moment.Moment;
    dateTo: moment.Moment;
    dateFormat: string = "default";

    static formats = {
        default: {
            withYear: "ddd D MMM YYYY",
            withoutYear: "ddd D MMM",
        },
        long: {
            withYear: "dddd D MMM YYYY",
            withoutYear: "dddd D MMM",
        },
        extraLong: {
            withYear: "dddd, D MMMM YYYY",
            withoutYear: "dddd, D MMMM",
        },
    };

    constructor(
        el: HTMLElement,
        dateFrom: moment.Moment = null,
        dateTo: moment.Moment = null
    ) {
        this.el = el;
        const dateTimeFrom = !dateFrom
            ? el.getAttribute("data-datetime-from") || ""
            : "";
        const dateTimeTo = !dateTo
            ? el.getAttribute("data-datetime-to") || ""
            : "";
        this.dateFrom = dateFrom || moment.unix(dateTimeFrom);
        this.dateTo = dateTo || moment.unix(dateTimeTo);

        const format = el.getAttribute("data-datetime-format");
        if (format) {
            this.dateFormat = format;
        }

        this.format();
    }

    _format = (date: moment.Moment): string => {
        return date.format(DateFormatter.formats[this.dateFormat].withYear);
    };

    format = () => {
        let str = "";
        // If range is in the same day
        // Print from
        if (this.dateFrom.isSame(this.dateTo, "day")) {
            str = this._format(this.dateFrom);
        }
        // If range falls over multiple days
        // Print from and to
        else {
            str = `${this._format(this.dateFrom)} to ${this._format(
                this.dateTo
            )}`;
        }
        this.el.innerHTML = str;
    };
}

class TimeFormatter {
    el: HTMLElement;
    dateFrom: moment.Moment;
    dateTo: moment.Moment;

    static timeFormat = "h:mma";

    constructor(
        el: HTMLElement,
        dateFrom: moment.Moment = null,
        dateTo: moment.Moment = null
    ) {
        this.el = el;
        const dateTimeFrom = !dateFrom
            ? el.getAttribute("data-datetime-from") || ""
            : "";
        const dateTimeTo = !dateTo
            ? el.getAttribute("data-datetime-to") || ""
            : "";
        this.dateFrom = dateFrom || moment.unix(dateTimeFrom);
        this.dateTo = dateTo || moment.unix(dateTimeTo);
        this.format();
    }

    _format = (date: moment.Moment): string => {
        return date.format(TimeFormatter.timeFormat);
    };

    format = () => {
        const str = `${this._format(this.dateFrom)} to ${this._format(
            this.dateTo
        )}`;
        this.el.innerHTML = str;
    };
}

const timeEls = document.querySelectorAll(".time-formatter");
timeEls.forEach((el: HTMLElement) => {
    new TimeFormatter(el);
});

const dateEls = document.querySelectorAll(".date-formatter");
dateEls.forEach((el: HTMLElement) => {
    new DateFormatter(el);
});
